import { createSelector } from 'reselect';
import { unique } from './sagas/helpers/unique';

const authData = (state) => state.authData;
const games = (state) => state.games;
const gameListIsLoading = (state) => state.games.loading;
const bettingGames = (state) => state.bettingGames;
const liveCasinoGames = (state) => state.liveCasinoGames;
const tournaments = (state) => state.tournaments;
const tournamentsCasino = (state) => state.tournamentsCasino;
const tournamentPlayers = (state) => state.tournamentPlayers;
const tournamentChatLastViews = (state) => state.tournamentChatLastViews;
const tournamentChats = (state) => state.tournamentChats;
const tournamentChatStatuses = (state) => state.tournamentChatStatuses;
const gameTags = (state) => state.gameTags;
const productsTypes = (state) => state.productsTypes;
const gameCategories = (state) => state.gameCategories;
const loadingGameUrls = (state) => state.loadingGameUrls;
const gameUrls = (state) => state.gameUrls;
const tournamentGameUrls = (state) => state.tournamentGameUrls;
const providers = (state) => state.providers;
const globalAccount = (state) => state.globalAccount;
const globalAccountBalance = (state) => state.globalBalance;
const clubList = (state) => state.clubsData;
const currentClub = (state) => state.currentClub;
const currentClubAdminAccount = (state) => state.currentClub.adminAccount;
const currentClubPlayerAccount = (state) => state.currentClub.playerAccount;
const tableList = (state) => state.tableList;
const clubMembers = (state) => state.currentClubMembers;
const messageList = (state) => state.messageList;
const unreadMessageList = (state) => state.unreadMessageList
const openedMessage = (state) => state.openedMessage;
const openedMessages = (state) => state.openedMessageIds;
const notification = (state) => state.notification;
const countOfUnreadMessages = (state) => state.countOfUnreadMessages;
const avatarMenu = (state) => state.avatarMenu;
const accountAvatars = (state) => state.accountAvatars;
const clubTransfers = (state) => state.clubTransfers;
const clubData = (state) => state.clubData;
const unionMembers = (state) => state.unionMembers;
const clubPokerFrames = (state) => state.clubPokerFrames;
const sentCode = (state) => state.verificationCode;
const clubProducts = (state) => state.clubProducts;
const currentAgentTransactions = (state) => state.currentAgentTransactions;
const currentAgentDetails = (state) => state.currentAgentDetails;
const currentMemberDetails = (state) => state.currentMemberDetails;
const avatarJSONs = state => state.avatarJSONs;
const dialog = state => state.dialog;
const selectedTab = state => state.selectedTab;
const gameTransfers = (state) => state.gameTransfers;
const flags = (state) => state.flags;

export const getGameTransfers = createSelector(
  gameTransfers,
  (g) => g.transfers
);

export const getGlobalAccount = createSelector(
  globalAccount,
  (g) => g
);

export const getGames = createSelector(
  games,
  (g) => g.entities,
);

export const getBettingGames =  createSelector(
  bettingGames,
  (g) => g.entities,
);

export const getLiveCasinoGames = createSelector(
  liveCasinoGames,
  (g) => g.entities,
);

export const getSelectedTournamentCasino = createSelector(
  tournamentsCasino,
  (c) => (c ? c.selected : null),
);

export const getWallet = createSelector(
  [authData,currentClub],
  (a, c) => (a.accounts ? a.accounts.find(u => u.clubId === c.clubId)['wallets'][0] : null)
);

export const getFPPWallet = createSelector(
  [authData,currentClub],
  (a, c) => (a.accounts ? a.accounts.find(u => u.clubId === c.clubId)['wallets'].find(w => w.currency === 'FPP') : null)
)

export const getGameTypes = createSelector(
  games,
  (g) => unique(g.entities.map((e) => e.gametype)),
);

export const getProviders = createSelector(
  providers,
  (p) => p.entities,
);

export const getProductsTypes = createSelector(
  productsTypes,
  (p) => p.entities,
);

export const getGameTags = createSelector(
  gameTags,
  (t) => t
);

export const getGameCategories = createSelector(
  gameCategories,
  (c) => c.list,
);

export const getSelectedCategory = createSelector(
  gameCategories,
  (c) => c.selected,
);

export const getGlobalToken = createSelector(
  globalAccount,
  (g) => g.token
);

export const getGlobalAccountId = createSelector(
  globalAccount,
  (g) => g.id
);

export const getAuthenticationStatus = createSelector(
  authData,
  (a) => !!a.authenticated
);

export const getOwnAccounts = createSelector(
    authData,
    (a) => a.accounts
);

export const getCurrentClubId = createSelector(
  currentClub,
  (cc) => cc.clubId
);

export const getGlobalClub = createSelector(
    clubList,
    (cl) => cl.find(c => c.isGlobal)
);

export const getCurrentAccount = createSelector(
    globalAccount,
    currentClub,
    (gbAcc, clubAcc) => (!!clubAcc && clubAcc.playerAccount) ? clubAcc.playerAccount : gbAcc
);

export const getCurrentAccountId = createSelector(
  globalAccount,
  currentClub,
  (gbAcc, clubAcc) => (!!clubAcc && clubAcc.playerAccount) ? clubAcc.playerAccount.id : gbAcc.id
);

export const getPokerFrame = createSelector(
  clubPokerFrames,
  currentClub,
  clubList,
  (pkrFrames, crClb, clbList) => (!!crClb && crClb.clubId) ? pkrFrames[crClb.clubId] : pkrFrames[clbList.find(c => c.isGlobal).clubId]
);

export const getCurrentClubAdminToken = createSelector(
  currentClub,
  (cb) => cb.adminAccount ? cb.adminAccount.token : null
);

export const getRoleInCurrentClub = createSelector(
    currentClub,
    (cb) => cb.clubRole
);

export const getUnionApprovedClubs = createSelector(
    unionMembers,
    (um) => um.approved || []
);
export const getUnionPendingClubs = createSelector(
    unionMembers,
    (um) => um.pending || []
);

export const getCurrentClubPlayerId = createSelector(
  currentClub,
  (g) => g.playerAccount ? g.playerAccount.id : null
);

export const getCurrentClubPlayerToken = createSelector(
  currentClub,
  (g) => g.playerAccount ? g.playerAccount.token : null
);

export const getCurrentClubAccountId = createSelector(
  currentClub,
  (cb) => cb.adminAccount ? cb.adminAccount.id : cb.playerAccount.id
);

export const getCurrentClubToken = createSelector(
  currentClub,
  (cb) => cb.adminAccount ? cb.adminAccount.token : cb.playerAccount.token
);

export const getCurrentClubAdminId = createSelector(
    currentClub,
    (cb) => cb.adminAccount.id
);

export const getCurrentClubApprovedMembers = createSelector(
  clubMembers,
  (cm) => cm.filter(m => m.status === 'enabled')
);

export const getCurrentClubPendingMembers = createSelector(
  clubMembers,
  (cm) => cm.filter(m => m.status === 'pending')
);

export const getClubChipBalance = createSelector(
  currentClubAdminAccount,
  currentClubPlayerAccount,
  (aa, pa) => !aa && !pa ? 0 : !!aa ?
    aa.wallets[0].balance :
    pa.wallets[0].balance
);

export const currentClubData = createSelector(
    getCurrentClubId,
    clubData,
    (id, cd) => !!cd && (id in cd) ? cd[id] : [],
);

export const getClubUnion = createSelector(
    currentClub,
    (cc) => cc.union
);
export const getClubUnionId = createSelector(
    currentClub,
    (cc) => cc.unionId
);

export const getClubTables = createSelector(
  globalAccount,
  currentClub,
  tableList,
  (gbAcc, currClub, tables) => (!!currClub && currClub.clubId) ? tables[currClub.clubId] : tables[gbAcc.clubId]
);

const jsonTest = /\.json$/i;

export const getAccountAvatars = createSelector(
  accountAvatars,
  avatarJSONs,
  (avatars, jsons) => {
    return Object.entries(avatars)
      .map(([id, a]) => {
        const { imagePath, name } = a;
        if (!jsonTest.test(imagePath)) return [id, a];
        const json = jsons[imagePath];
        if (!json) return [id, a];
        const frame = json.frames.find(f => f.filename === name);
        const newPath = imagePath.replace(jsonTest, '.png');
        return [id, { imagePath: newPath, ...frame }];
      })
      .reduce((acc, [id, a]) => {
        acc[id] = a;
        return acc;
      }, {});
  },
);

export const getGlobalAccountAvatar = createSelector(
  globalAccount,
  getAccountAvatars,
  (gbAcc, avs) => (!!gbAcc && !!gbAcc.id && avs) ? avs[gbAcc.id] : {}
);

export const getDialogParams = createSelector(
  dialog,
  d => d.params ? d.params : {},
);

export const getTournamentRegisterFormIsLoading = createSelector(
  flags,
  (f) => f.tournamentCasinoRegisterFormIsLoading,
);

export const getTournamentRegisterIsSuccessful = createSelector(
  flags,
  (f) => f.tournamentCasinoRegisterIsSuccessfull,
);

export const getTournamentUnregisterIsSuccessfull = createSelector(
  flags,
  (f) => f.tournamentCasinoUnregisterIsSuccessfull,
);

export const getTournamentChatUnread = createSelector(
  tournamentChats,
  tournamentChatLastViews,
  (tc, lv) => {
    const result = {};
    Object.keys(tc).forEach(tid => {
      result[tid] = !lv[tid] ? tc[tid].length : tc[tid].filter(m => !m.self && m.on > lv[tid]).length;
    });
    return result;
  },
  // Object.keys, Object.values, Object.entries
);

export const getAvatarMenu = avatarMenu;
export const getAuthenticationData = authData;
export const getGlobalAccountBalance = globalAccountBalance;
export const getCurrentClubAdminAccount = currentClubAdminAccount;
export const getCurrentClubPlayerAccount = currentClubPlayerAccount;
export const getClubTransfers = clubTransfers;
export const getClubList = clubList;
export const getCurrentClub = currentClub;
// export const getClubTables = clubTables;
export const getMessageList = messageList;
export const getUnreadMessageList = unreadMessageList;
export const getOpenedMessage = openedMessage;
export const getOpenedMessages = openedMessages;
export const getNotification = notification;
export const getCountOfUnreadMessages = countOfUnreadMessages;
export const getPokerFrames = clubPokerFrames;
export const getLoadingGameUrls = loadingGameUrls;
export const getGameUrls = gameUrls;
export const getTournamentGameUrls = tournamentGameUrls;
export const getTournaments = tournaments;
export const getTournamentPlayers = tournamentPlayers;
export const getTournamentChatLastViews = tournamentChatLastViews;
export const getTournamentChatStatuses = tournamentChatStatuses;
export const getTournamentChats = tournamentChats;
export const getSentCode = sentCode;
export const getClubProducts = clubProducts;
export const getCurrentAgentTransactions = currentAgentTransactions;
export const getCurrentAgentDetails = currentAgentDetails;
export const getCurrentMemberDetails = currentMemberDetails;
export const isGameListLoading = gameListIsLoading;
export const getSelectedTab = selectedTab;